import { RolesEnums } from '@/store/enums/RolesEnums';

const app = {
  path: '/',
  redirect: '/starting',
  // component: () => import("@/layout/Layout.vue"),
  meta: { roles: [RolesEnums.ALL] },
  children: [
    {
      path: '/starting',
      name: 'starting',
      meta: { roles: [RolesEnums.ALL] },
      component: () => import('@/views/pages/Starting.vue')
    }

  ]
};
export default app;
